/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import axios from 'axios';

/**
 * setup.js — client API per l'Installer Wizard. Non usa i cookie di sessione:
 * l'autenticazione avviene con il token di setup (header X-Setup-Token).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api/setup`;
const TOKEN_KEY = 'sanitanexus.setup.token';

export const getSetupToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setSetupToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getSetupToken();
  if (t) cfg.headers['X-Setup-Token'] = t;
  return cfg;
});

export const setupStatus = () => client.get('/status').then((r) => r.data);
export const setupLogin = (password) => client.post('/login', { password }).then((r) => r.data);
export const setupTestDb = (database_url) => client.post('/test-db', { database_url: database_url || null }).then((r) => r.data);
export const setupLogo = (data_uri) => client.post('/logo', { data_uri }).then((r) => r.data);
export const setupBrand = (body) => client.post('/brand', body).then((r) => r.data);
export const setupCreateAdmin = (body) => client.post('/admin', body).then((r) => r.data);
